var fullURLtoHideZendesk = window.location.href;

if (fullURLtoHideZendesk.startsWith("https://www.nakedandthriving.com/es")) {
  window.onload = function () {
    $(".isense-cc-message").html(
      "Mantener segura tu información personal es importante para nosotros. Para ayudar a que este sitio funcione bien y tengas la mejor experiencia, utilizamos cookies, y con tu consentimiento previo también usaremos estas cookies por otras razones analíticas y funcionales, incluyendo personalizar tu experiencia en cuanto a promociones y anuncios. Para aceptar todas las cookies, simplemente haz clic en “Aceptar y cerrar”. De lo contrario, haz clic en “Gestionar preferencias” para personalizar tus opciones. Al hacer clic en “Continuar sin aceptar” continuarás navegando sin las cookies no técnicas. Si quieres aprender más sobre las cookies da <a href='/pages/privacy'>click aqui</a>."
    );
    $(".isense-cc-deny").text("CONTINUAR SIN ACEPTAR");
    $(".isense-cc-settings").text("GESTIONAR PREFERENCIAS");
    $(".isense-cc-allow").text("ACEPTAR Y CERRAR");
  };

  // Popup Offers
  $('.cxl_popup_title').text('Ofertas por Tiempo Limitado');
  // $('.cxl_button_1').text('APLICAR CUPÓN');
  // $('.cxl_button_2').text('APLICAR CUPÓN');
  $('.cxl_button_disabled').html('NO NECESITA <br> CUPON');
  // $('.cxl_popup_text.cxl_popup_text_travel').html('¡Obtén un producto Mini Gratis con la compra de cualquier producto de tamaño regular con el código <span>TRAVEL*</span>!');
  // $('.cxl_popup_text_triple ').html('¡Gasta <span class="cxl_sale_offer_mount" data-uw-rm-sr="">$200</span>   &amp; obtén gratis  Vitamin C Booster (¡un valor de <span class="cxl_value-t" data-uw-rm-sr="">$68</span>!) Usa el código VITAMIN*');
  $('.freeShippingOrder').text('Envío GRATIS en pedidos de más de $50');
  $('.cxl_note').text('Estas ofertas no se pueden combinar con otras ofertas y solo se pueden usar una vez por cliente');



  const callbackTranslate = function (mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const targetElementTranslate = mutation.target;
        if (targetElementTranslate.classList.contains("js-drawer-open")) {
          setTimeout(() => {
            $(".limoniapps-discountninja-cartdiscountfield-apply").text(
              "APLICAR"
            );
            $(".limoniapps-discountninja-cartdiscountfield-input").attr(
              "placeholder",
              "Ingresa el cupón aquí"
            );
            $(
              ".limoniapps-discountninja-cartdiscountfield-applied p span"
            ).text(
              "El código de descuento se aplicará al finalizar la compra si cumple con los requisitos"
            );
            $(".limoniapps-discountninja-cartdiscountfield-notapplied font").text("El código de descuento se aplicará al finalizar la compra si cumple con los requisitos")
            $(".limoniapps-discountninja-cartdiscountfield-notfound p").text('Lo sentimos, el cupón no se puede aplicar. Asegúrate de que sea válido.')
            $(".limoniapps-discountninja-cartdiscountfield-searching span").text("Cargando...");
          }, 700);
        }
      }
    }
  };

  const observerTranslate = new MutationObserver(callbackTranslate);

  const config = {
    attributes: true,
    attributeFilter: ["class"],
    subtree: false,
  };

  observerTranslate.observe(document.body, config);

  /// hidden zendesk in spanish version
  window.addEventListener('load', function () {
    if (typeof zE !== 'undefined') {
      zE(function () {
        zE.hide();
      });
    }
  });
}



document.addEventListener("DOMContentLoaded", function () {
  var patterns = [
    "/products/rutina-refrescante-refresh-renew-rejuvenate",
    "/products/renew-serum-nocturno-renovador",
    "/products/copy-of-the-night-set-renew-rejuvenate",
    "/products/set-de-serums-radiante-protect-renew-illuminate",
    "/products/rutina-nocturna-restauradora-renew-revive-rejuvenate",
    "/products/copy-of-the-wrinkle-fighter-set-limited-edition-gift-set"
  ];

  var urlContainsPattern = patterns.some(pattern => window.location.href.includes(pattern));

  function tryChangeLanguage(attemptsLeft, languageCode) {
    var languageToggle = document.querySelector('.weglot_switcher');
    var languageOption = document.querySelector(`li[data-l="${languageCode}"] a`);

    if (languageToggle && languageOption) {
      languageToggle.click();
      setTimeout(function () { languageOption.click(); }, 200);
    } else if (attemptsLeft > 0) {
      setTimeout(function () { tryChangeLanguage(attemptsLeft - 1, languageCode); }, 200);
    }
  }

  if (urlContainsPattern) {
    tryChangeLanguage(10, 'es');
  } else {
    tryChangeLanguage(10, 'en');
  }


});
